import { render, staticRenderFns } from "./ProductionCapacityAdd.vue?vue&type=template&id=b0035be8"
import script from "./ProductionCapacityAdd.vue?vue&type=script&lang=js"
export * from "./ProductionCapacityAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports